module.exports = __webpack_public_path__ + "img/mha_7.4bf42539.jpg";